import { createContext } from "react";

import { AccountAuth } from "../services/auth/AccountAuth";

export const AuthContext = createContext(AccountAuth);

export const AuthContextProvider = AuthContext.Provider;

export const AuthContextConsumer = AuthContext.Consumer;
